import { Navigate } from 'react-router-dom';
import { getAccessToken } from '../../utils/token';

const Route = ({ children }: { children: JSX.Element }) => {
    const token = getAccessToken();
    if (!token) {
        return <Navigate to="/" replace />;
    }
    return children;
};
export default Route;
